import ReactDOM from "react-dom/client";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import { EnvironmentConfig } from "./config/environmentConfig";
//import { DataProvider } from './contexts/DataContext/DataContext';
import { LayoutProvider } from "./contexts/Layout/LayoutContext";
import { DataProvider } from "./contexts/DataContext/DataContextt";
import { PreloadProvider } from "./contexts/DataContext/PreloadContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
// Replace with your Auth0 app values
const domain = EnvironmentConfig.auth0.domain;
const clientId = EnvironmentConfig.auth0.clientId;
const redirectUri = EnvironmentConfig.auth0.redirectUri;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: redirectUri,
      audience: audience,
      scope: "openid profile email offline_access",
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
  >
    <PreloadProvider>
      <DataProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </DataProvider>
    </PreloadProvider>
  </Auth0Provider>,
);

{
  /*
    <LayoutProvider>
      <DataProvider>
      
        <App />

      </DataProvider>
    </LayoutProvider>*/
}
